import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength, containsOnlyLetters } from '@gig/magic-form-builder';

function lastName() {
    return {
        id: 'lastName',
        serverId: 'familyName',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-lastname',
        properties: {
            placeholder: translate('sign-up-step-two.last-name.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-two.last-name.required-error'),
            },
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-two.last-name.min-length-error'),
            },
            {
                name: 'max-length',
                fn: maxLength(40),
                message: translate('sign-up-step-two.last-name.max-length-error'),
            },
            {
                name: 'contains-only-letters',
                fn: containsOnlyLetters,
                message: translate('sign-up-step-two.contains-only-letter-error'),
            },
        ],
    };
}

export { lastName };
